import { jobHours } from "./jobHours.data";

import {
    addStudentHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addStudentHandler.currentRequest";
import bluePlus from "../../../../../../common/Inputs/DatePeriodControlled/BluePlusCircle.svg";
import {
    deleteStudentHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/deleteStudentHandler.currentRequest";
import redPlus from "../../../../../../common/Inputs/DatePeriodControlled/RedRotatedPlusCircle.svg";

import DropdownForRecruitment from "../../../../../../common/Menu/DropdownForRecruitment/DropdownForRecruitment";

import DateSelectorList from "../../../../../../common/DateSelectorList/DateSelectorList";

import DropdownMenuTest from "../../../../../../common/Menu/DropdownMenuTest/DropdownMenuTest";

import DropdownMenu from "../../../../../../common/Menu/DropdownMenu/DropdownMenu";

import DatePopupSelector from "../../../../../../common/Inputs/Calendar/DatePopupSelector/DatePopupSelector";

import {
    addObjKeyYoArrayAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addObjKeyYoArray.action";

import {
    inputValidationInArray,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/inputValidationInArray";
import { useCustomDebounce } from "../../../../../../../hooks/UseCustomDebounce/UseCustomDebounce";
import { useDebounce } from "../../../../../../../hooks/useDebounce/useDebounce";

import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";

import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { element } from "prop-types";

const AddStudentsButton = (
    {
        parentStyle,
        // setState,
    },
) => {
    const dispatch = useDispatch();

    function addStudentHandler(e) {
        dispatch(addStudentHandlerCurrentRequest({
            stateName: "employees",
            data: {
                pid: null,
                days: [],
            },
        }));
    }

    return (
        <div className={`${parentStyle}__button`}>
            <span>Добавить еще одного работника</span>
            <img
                onClick={addStudentHandler}
                className={`${parentStyle}__button__blue-plus`}
                src={bluePlus}
                alt="bluePlus"
            />
        </div>
    );
};

const DeleteStudentsButton = (
    {
        parentStyle,
        // setState,
        index,
    },
) => {
    const dispatch = useDispatch();

    function deleteStudentHandler(e) {
        dispatch(deleteStudentHandlerCurrentRequest({ index, stateName: "employees" }));
    }

    return (
        <div className={`${parentStyle}__button`}>
            <span>Удалить добавленного ниже работника</span>
            <img
                onClick={deleteStudentHandler}
                className={`${parentStyle}__button__red-plus`}
                src={redPlus}
                alt="redPlus"
            />
        </div>
    );
};


const Employe = (
    {
        employee,
        parentStyle,
        index,
        employeesLength,
    },
) => {
    const dispatch = useDispatch();
    const currentRequest = useSelector(
        (state) => state.requests.currentRequest,
    );
    const subordinates = useSelector(state => state.requests.subordinates);

    //search employee START

    //search employee END
    function selectDropdown(event, element, stateProperty) {
        dispatch(
            inputValidationInArray({
                fieldElement: "pidValid",
                bool: true,
                indexArray: index,
                arrayField: "employees",
            }),
        );
        dispatch(addObjKeyYoArrayAction({
            arrayKey: null,
            objKeyName: stateProperty,
            objKey: element.pid,
            indexInArray: null,
            elementIndex: index,
            fieldArray: "employees",
        }));
        dispatch(addObjKeyYoArrayAction({
            arrayKey: null,
            objKeyName: "visibleIndex",
            objKey: false,
            indexInArray: null,
            elementIndex: index,
            fieldArray: "employees",
        }));
    }


    return (
        <div key={uuidv4()} className={`${parentStyle}__employe`}>
            {employeesLength > 1 && index !== 0 && (
                <DeleteStudentsButton parentStyle={parentStyle} index={index} />
            )}
            <div className={`${parentStyle}__employe__select`}>
                <DropdownForRecruitment
                    fieldArray={"employees"}
                    index={index}
                    currentRequest={currentRequest && currentRequest["employees"] && currentRequest["employees"][index] && currentRequest["employees"][index]}
                    helper={
                        // eslint-disable-next-line max-len
                        "В списке не отображаются сотрудники, не перешедшие на ЭДТО и сотрудники, ЭДТО которых приостановлено." +
                        " Статус ЭДТО сотрудников можно узнать в разделе «Список сотрудников». "
                    }
                    styleName={"recruitment"}
                    label={"Выберите работника для привлечения к работе в выходные, праздничные дни *"}
                    listOfOptions={ subordinates}
                    stateProperty={"pid"}
                    selectOptionClick={selectDropdown}
                    isValidKey={
                        currentRequest &&
                        currentRequest["employees"] &&
                        currentRequest["employees"][index] &&
                        currentRequest["employees"][index].pidValid
                    }

                />
            </div>

            {
                currentRequest && currentRequest["employees"] && currentRequest["employees"][index] && currentRequest["employees"][index]?.pid ?
                    <DateSelectorList
                        employees={currentRequest &&
                            currentRequest["employees"]}
                        parentStyle={parentStyle}
                        element={employee}
                        elementIndex={index}
                        isValidKey={
                            currentRequest &&
                            currentRequest["employees"] &&
                            currentRequest["employees"][index] &&
                            currentRequest["employees"][index]
                        }
                    /> : null
            }



            {index === employeesLength - 1 && (
                <AddStudentsButton parentStyle={parentStyle} />
            )}
        </div>
    );
};

export default Employe;
